import { render, staticRenderFns } from "./PaymentMethodModal.vue?vue&type=template&id=3bd4f460&scoped=true"
import script from "./PaymentMethodModal.vue?vue&type=script&lang=js"
export * from "./PaymentMethodModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd4f460",
  null
  
)

export default component.exports